import React from 'react';
import PropTypes from 'prop-types';

import ContentView from './ContentView';
import ContentEdit from './ContentEdit';

const Content = (props) => {
  const mode = props.mode;

  if (mode === 'VIEW') {
    return (
      <ContentView
        {...props}
      />
    );
  } else if (mode === 'EDIT') {
    return (
      <ContentEdit
        {...props}
      />
    );
  } else {
    return null;
  }
};

Content.propTypes = {
  mode: PropTypes.string.isRequired,
};

export default Content;
